import React, { Dispatch, SetStateAction } from 'react';
import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/modal';
import { Textarea, Button } from '@landsvirkjun/react.common';
import { FormLabel } from '@chakra-ui/form-control';

type RejectionModalProps = {
  isOpen: boolean;
  onClose: () => void;
  reasonForDenied: string;
  setReasonForDenied: Dispatch<SetStateAction<string>>;
  onRejectRequest: () => void;
  isUpdatingStatus: boolean;
  isReviewed?: boolean;
  status: string;
};
type StatusMessage = {
  header: string;
  label: string;
  button: string;
};

const statusMessage = {
  default: {
    header: 'Ástæða höfnunar',
    label: 'Vinsamlegast skrifaðu inn ástæðu fyrir höfnun',
    button: 'Hafna beiðni',
  },
  secondary: {
    header: 'Endurskoðun kostnaðar ',
    label:
      'Vinsamlegast skráðu ástæðu fyrir því að kostnaður þurfi endurskoðun',
    button: 'Óska eftir endurskoðun',
  },
};

const getModalMessage = (status: string): StatusMessage => {
  return status === 'COST_REVIEWED' ||
    status === 'COST_IN_REVIEW' ||
    status === 'COST_CONFIRMED' ||
    status === 'COST_APPROVED'
    ? statusMessage.secondary
    : statusMessage.default;
};

export const RejectionModal = ({
  isOpen,
  onClose,
  reasonForDenied,
  setReasonForDenied,
  onRejectRequest,
  isUpdatingStatus,
  status,
}: RejectionModalProps): JSX.Element => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{getModalMessage(status).header}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <FormLabel>{getModalMessage(status).label}</FormLabel>
          <Textarea
            placeholder="..."
            value={reasonForDenied}
            onChange={(e): void => setReasonForDenied(e.target.value)}
          />
        </ModalBody>

        <ModalFooter>
          <Button variant="warning" mr={3} onClick={onClose}>
            Hætta við
          </Button>
          <Button
            variant="primary"
            isDisabled={reasonForDenied === ''}
            onClick={onRejectRequest}
            isLoading={isUpdatingStatus}
            loadingText="Augnablik..."
          >
            {getModalMessage(status).button}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
